module.exports = require('./../dist/src/system/dist/components/Close.js');
